import { PINNED_STORAGE_KEY } from '../constants';
import type { IBookmarkGroup } from '../types';

export const setBookmarkCount = (bookmarks: number) => {
  const pinIcon = document.querySelector('.df-header__bookmarks__icon') as HTMLElement;
  const pin = document.querySelector('.df-header__bookmarks__count') as HTMLElement;
  if (!pin) return;
  const regex = /\(\d+\)/gi;
  if (pin.innerText.match(regex)) {
    if (bookmarks === 0) {
      pinIcon.classList.remove('df-header__bookmarks__icon--active');
      pin.innerText = pin.innerText.replace(regex, '');
    } else {
      pinIcon.classList.add('df-header__bookmarks__icon--active');
      pin.innerText = pin.innerText.replace(regex, `(${bookmarks})`);
    }
  } else if (bookmarks > 0) {
    pinIcon.classList.add('df-header__bookmarks__icon--active');
    pin.innerText = `${pin.innerText} (${bookmarks})`;
  }
};

export const readBookmarksFromStorage = () => {
  const storageValue = window.localStorage?.getItem(PINNED_STORAGE_KEY);
  if (!storageValue) return [];
  let bookmarks = [];
  try {
    bookmarks = JSON.parse(storageValue);
  } catch (e) {
    console.error((e as Error).message);
  }
  return Array.isArray(bookmarks) ? (bookmarks as Array<{ id: number; group: number }>) : [];
};

export const sortBookmarksByPinOrder = (
  sortArray: Array<{ id: number; group: number }>,
  bookmarkData: Array<IBookmarkGroup>,
): IBookmarkGroup[] => {
  return bookmarkData
    .filter(Boolean)
    .sort((a, b) => {
      const first = sortArray.find((element) => element.group === a.pimId);
      const second = sortArray.find((element) => element.group === b.pimId);
      if (!first || !second) {
        return 0;
      }
      return sortArray.indexOf(first) - sortArray.indexOf(second);
    })
    .reverse();
};
